import { AfterViewInit, Component, OnInit } from '@angular/core';
import { GoogleAuthService } from './../google-auth.service';
import { GoogleUserProfile } from './../google-sdk';

@Component({
    selector: 'app-google-login',
    templateUrl: './google-auth-popup.component.html'
})
export class GoogleAuthPopupComponent implements OnInit, AfterViewInit {

    constructor(private _authService: GoogleAuthService) {
    }

    ngOnInit() {
    }
    async ngAfterViewInit() {
        await this.handleClose();
    }
    public async handleClose() {
        const callBackInfo = await this._authService.isAuthBack();
        if (callBackInfo.isCallBack) {
            if (window.opener) {
                window.opener.postMessage({
                    type: 'AUTH_SUCCESS',
                    authBack: callBackInfo
                }, window.location.origin);
            }
            window.close();
            return;
        }
        console.log('start login');
        this._authService.login();
    }
}

